import { Box } from "@mui/material";
import React from "react";
import type { FieldConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField, ReportField } from "../../../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../../../api/types/svTypes.ts";
import { isDimension } from "../../../../utilities/fieldsHelper.ts";
import ShowLogoIconComponent from "../../common/fields/format/ShowLogoIconComponent.tsx";
import TextField from "../../common/fields/format/TextField.tsx";
import { isFieldSupportedLogoIcon } from "../../common/fields/format/isFieldSupportedLogoIcon.ts";

const getTextFields = (fields: ReportField[]): DimensionField[] => {
  return fields.filter(isDimension).filter((v) => v.meta.type === ItemDataType.General);
};

interface Props {
  fields: DimensionField[];
  onUpdateConfig: (field: ReportField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

export default function TextFieldContainer({ fields, onUpdateConfig, readonlyMode }: Props) {
  const textFields = React.useMemo(() => getTextFields(fields).filter(isFieldSupportedLogoIcon), [fields]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
      {textFields.map((field) => (
        <TextField key={field.meta.name} field={field}>
          <ShowLogoIconComponent field={field} onUpdateConfig={onUpdateConfig} readonlyMode={readonlyMode} />
        </TextField>
      ))}
    </Box>
  );
}
